import { getStoredUser } from './authentication';

export const isDoctorUser = (user) =>
  String(user?.user_type_name ?? user?.userType?.name ?? '').toLowerCase() === 'doctor';

export const getDoctorClientId = (user) => {
  const resolved = user ?? getStoredUser();
  const clientId = resolved?.client_id;
  return clientId != null && clientId !== '' ? Number(clientId) : null;
};

/** Menu pages hidden for doctor portal users (catalog/admin views). */
export const DOCTOR_HIDDEN_MENU_PAGES = new Set([
  'colors',
  'formula_types',
  'platform_settings',
  'delivery_centers',
  'wallets',
  'clients',
  'doctors',
  'setting',
]);

/** Menu pages hidden for non-doctor vendor users. */
export const VENDOR_HIDDEN_MENU_PAGES = new Set([
  'client_settings',
  'client_transactions',
]);

/** URL prefixes doctors cannot browse (see DoctorPortalGuard). */
export const DOCTOR_BLOCKED_PATH_PREFIXES = [
  '/clients',
  '/delivery-centers',
  '/wallets',
  '/doctors',
  '/colors',
  '/formula-types',
  '/platform-settings',
];
